import { V1_RECEIVE_NOTIFICATIONS } from '../../actions/notifications/v1receiveNotifications'
import { V1_RESET_NOTIFICATIONS } from '../../actions/notifications/v1resetNotifications'

export const initialState = {
  notifications: [],
}

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case V1_RECEIVE_NOTIFICATIONS:
      return {
        ...state,
        notifications: action.notifications,
      }

    case V1_RESET_NOTIFICATIONS:
      return {
        ...state,
        notifications: [],
      }

    default:
      return state
  }
}
